// src/components/auth/IdleLogoutModal.jsx
import React from "react";
import { useLanguage } from "@/contexts/LanguageContext.jsx";

const idleAlertIcon = "/icons/idle-alert.svg";

export default function IdleLogoutModal({
  open,
  secondsLeft = 0,
  onStay,
  onLogout,
}) {
  const { t } = useLanguage();
  if (!open) return null;

  const secs = Math.max(0, Number(secondsLeft || 0));
  const mm = String(Math.floor(secs / 60)).padStart(1, "0");
  const ss = String(secs % 60).padStart(2, "0");

  return (
    <div
      className="fixed inset-0 z-[120] bg-[rgba(15,23,42,0.35)] backdrop-blur-sm flex items-end md:items-center justify-center"
      role="dialog"
      aria-modal="true"
      onClick={(e) => e.stopPropagation()}
    >
      <div
        className="w-full md:w-[420px] rounded-t-2xl md:rounded-2xl bg-[rgb(var(--clr-surface-cont-highest))] shadow-[0_18px_45px_rgba(15,23,42,0.18)] overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="p-5 md:p-6">
          <div className="flex items-start gap-3">
            <span
              aria-hidden="true"
              className="mt-0.5 h-6 w-6 bg-[rgb(var(--clr-on-surface))]"
              style={{
                WebkitMaskImage: `url(${idleAlertIcon})`,
                maskImage: `url(${idleAlertIcon})`,
                WebkitMaskRepeat: "no-repeat",
                maskRepeat: "no-repeat",
                WebkitMaskPosition: "center",
                maskPosition: "center",
                WebkitMaskSize: "contain",
                maskSize: "contain",
              }}
            />
            <div className="min-w-0">
              <div className="text-title-medium text-on-surface">
                {t("auth.idleLogout.title", "Are you still there?")}
              </div>
              <div className="mt-1 text-body-medium text-on-surface-var">
                {t(
                  "auth.idleLogout.bodyLead",
                  "For your security, we'll log you out in"
                )}{" "}
                <span className="text-on-surface">{mm}:{ss}</span>{" "}
                {t(
                  "auth.idleLogout.bodyEnd",
                  "if there's no activity."
                )}
              </div>
            </div>
          </div>

          <div className="mt-5 flex items-center justify-center gap-3">
            <button
              type="button"
              className="flex-1 rounded-xl px-4 py-3 text-label-large disabled:opacity-60"
              style={{
                background:
                  "var(--State-Layers-Critical-Opacity-08,rgba(248,83,58,0.08))",
                color: "var(--Schemes-Critical,#F8533A)",
              }}
              onClick={onLogout}
            >
              {t("auth.idleLogout.logOut", "Log out")}
            </button>

            <button
              type="button"
              className="flex-1 rounded-xl px-4 py-3 text-label-large disabled:opacity-60"
              style={{
                background:
                  "var(--State-Layers-Primary-Opacity-08,rgba(29,79,215,0.08))",
                color: "var(--Schemes-Primary,#1D4FD7)",
              }}
              onClick={onStay}
            >
              {t("auth.idleLogout.staySignedIn", "Stay signed in")}
            </button>
          </div>
        </div>

        <div className="h-px bg-[rgba(15,23,42,0.06)]" />
      </div>
    </div>
  );
}
